import { render } from "./AnnouncementsComponent.vue?vue&type=template&id=5f99d2d4&scoped=true"
import script from "./AnnouncementsComponent.vue?vue&type=script&lang=js"
export * from "./AnnouncementsComponent.vue?vue&type=script&lang=js"

import "./AnnouncementsComponent.vue?vue&type=style&index=0&id=5f99d2d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f99d2d4"]])

export default __exports__